import { Injectable } from '@angular/core';

import { IntegrationsApiService } from '@recruitee/integrations/http';
import { IntegrationKinds } from '@recruitee/integrations/types';

@Injectable({ providedIn: 'root' })
export class ZoomApiService extends IntegrationsApiService {
  public context: string = IntegrationKinds.ZOOM;
}
